export default __webpack_public_path__ + "static/media/7.8bde7a8c.jpg";